<script setup>

    import Modal from '@/Components/App/Modal.vue'
    import PrimaryButton from '@/Components/Forms/PrimaryButton.vue'
    import SecondaryButton from '@/Components/Forms/SecondaryButton.vue'
    import DangerButton from '@/Components/Forms/DangerButton.vue'
    import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

    const props = defineProps({
    show: { type: Boolean, required: true },
    title: { type: String, required: false, default: '' },
    message: { type: String, required: false, default: '' },
    actionLabel: { type: String, required: false, default: 'Confirm' },
    cancelLabel: { type: String, required: false, default: 'Cancel' },
    actionIsDanger: { type: Boolean, required: false, default: false },
    maxWidth: { type: String, required: false, default: 'md' },
    actionDisabled: { type: Boolean, required: false, default: false },
    layerClass: { type: String, required: false, default: undefined },
    })

    const emit = defineEmits(['confirm','close'])

    function onConfirm() {
    if (props.actionDisabled) return
    emit('confirm')
    }

    function onClose() {
    emit('close')
    }

</script>

<template>
    <Modal :show="props.show" :maxWidth="props.maxWidth" :layerClass="props.layerClass" @close="onClose">
        <div class="p-6">
            <div class="sm:flex sm:items-start">
            <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-lifeworx-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                <ExclamationTriangleIcon class="h-6 w-6 text-lifeworx-orange-600" aria-hidden="true" />
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 class="text-base font-semibold leading-6 text-lifeworx-blue-800">{{ title }}</h3>
                <p class="mt-2 text-sm text-stone-500">{{ message }}</p>
            </div>
            </div>

            <div class="mt-6 flex justify-end">
            <SecondaryButton @click="onClose">{{ cancelLabel }}</SecondaryButton>
            <component
                :is="actionIsDanger ? DangerButton : PrimaryButton"
                class="ml-3"
                :disabled="actionDisabled"
                @click="onConfirm"
            >
                {{ actionLabel }}
            </component>
            </div>
        </div>
    </Modal>
</template>
